import Intercom from '@intercom/messenger-js-sdk'
import LogRocket from 'logrocket'
import mixpanel from 'mixpanel-browser'

export const SM = {
  env: (location.hostname.includes('test') ? 'development' : 'production'),
  forcedPlatform: undefined as 'ios' | 'md' | undefined,
  takeHomePercent: 1, // must be number, 100%
  bookingFeePercent: 0.035, // must be number, 3.5%
}
if (location.hostname === 'ios.test') SM.forcedPlatform = 'ios'
if (location.hostname === 'android.test') SM.forcedPlatform = 'md'
if (window.innerWidth > 800) SM.forcedPlatform = 'md' // force to desktop on larger screens

export const BLACKHAWK_ACADEMY_DEFAULT_LOCATION = '124dd6b9-5fb2-4ebf-967c-52a67cf15241'

export const STRIPE_TEST_PUBLIC_KEY = 'pk_test_51MEFdqFC8jMPZvbWkzZbJejJ5hUlyXFGwl07koZB8GWUhMDXv8K8PXasUemekzZqVkNmfPZrf8oPjcNn7DNEeazB00dXLOeh2S'

export const STRIPE_PUBLIC_KEY = SM.env === 'development'
  ? STRIPE_TEST_PUBLIC_KEY
  : 'pk_live_51MEFdqFC8jMPZvbWGE67M2WS118Mp0vTfVPn1CYAlsK44VZtJS4WqZWYREN5BajqlWTnPCimf7XMrpVeGhFjfuHG00FBqTS7Tf'

export function trackEvent(name: string, metadata = {}) {
  if (SM.env !== 'production') return
  if (window.Intercom) window.Intercom('trackEvent', name, metadata)
  mixpanel.track(name, metadata)
}

export function identifyUser(userDocData: any) {
  if (SM.env !== 'production') return
  const intercomData = {
    app_id: 'dfro638p',
    user_id: userDocData.id,
    name: userDocData.name,
    email: userDocData.email,
    phone: userDocData.phone,
    created_at: userDocData.createdAt,
    custom_launcher_selector: '#intercom_custom_launcher',
    ['User Type']: userDocData.type,
    ['User About']: userDocData.about,
  }
  Intercom(intercomData)
  LogRocket.identify(userDocData.email, {
    name: userDocData.name,
    email: userDocData.email,
    // Add your own custom user variables here, ie:
    userType: userDocData.type,
  })
  mixpanel.identify(intercomData.user_id)
  mixpanel.people.set({
    $name: intercomData.name,
    $email: intercomData.email,
    created_at: intercomData.created_at?.seconds,
    userType: intercomData['User Type'],
    phone: intercomData.phone,
  })
}

export type Branding = { logo: string, name: string, defaultLocations: string[] | null }
export const branding: Branding = window.location.hostname.includes('blackhawkacademy')
  ? { logo: 'blackhawkacademy.webp', name: 'Blackhawk Academy', defaultLocations: [BLACKHAWK_ACADEMY_DEFAULT_LOCATION] }
  : { logo: 'swingmatch.svg', name: 'SwingMatch Golf', defaultLocations: null }
